import React from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import { style } from "./style";
import { withRouter } from "react-router-dom";

class SideMenuComponentsHeader extends React.Component {
  constructor(props) {
    super();
    this.state = {};
  }

  close = () => {
    this.props.resetEntity();
    this.props.history.push("/dashboard");
  };

  render() {
    const { title, stepInfo } = this.props;
    return (
      <div className={css(style.header)}>
        <div className={css(style.headerOne)}>
          <div className={css(style.title)}>{title}</div>
          <div className={css(style.divContainer)}>
          {!!this.props?.CustomDateRangeFilter && <div>{this.props?.CustomDateRangeFilter}</div>}
            <div className={css(style.divIcon)}>
            <span
              className={css(style.iconsMenu)}
              title="Close"
              onClick={this.close}
            >
              <img
                className={css(style.imageiconsMenu)}
                alt="close"
                src="/images/close_icon.png"
              />
            </span>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (store) => {
    return {};
  },
  (dispatch) => {
    return {
      resetEntity: () => {
        dispatch({
          type: "RESET_ENTITY_DATA",
        });
      },
    };
  }
)(withRouter(SideMenuComponentsHeader));
